<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-title"></h2>
<div class="blockquote">
<p class="noindent">TO</p>
<p class="noindent">JOHNNY JOE</p>
<p class="noindent">Who could have been</p>
<p class="noindent">the best dice arm of them all,</p>
<p class="noindent">but who died too soon.<a id="page_3"></a><a id="page_4"></a></p><a id="page_4">
</a></div><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm1.vue?132f9992